export const STATIC_LOGO = 'https://firebasestorage.googleapis.com/v0/b/monittor-dev.appspot.com/o/images%2FUYIJZxcmrur854V67DEN_image.png?alt=media&token=5b4c36c3-234f-4001-99dc-7d26346d4424'
